import { CATALOGUE_ACTION_TYPES } from './actionTypes';
import { catalogueApi } from './api';

/**
 * Загружает каталог и извлекает cat_ID в порядке ключей API.
 * Результат: упорядоченный массив categoryIds, например [41, 69, 68, 74]
 */
export const fetchCatalogue = () => {
    return async (dispatch) => {
        dispatch({ type: CATALOGUE_ACTION_TYPES.FETCH_REQUEST });

        try {
            const data = await catalogueApi.fetchCatalogue();

            const categories = data.featured_categories;

            const categoryIds = Object.keys(categories)
                .sort((a, b) => Number(a) - Number(b))
                .map(key => categories[key].cat_ID)
                .filter(Boolean);

            dispatch({
                type: CATALOGUE_ACTION_TYPES.FETCH_SUCCESS,
                payload: { categoryIds },
            });
        } catch (error) {
            console.error('❌ Catalogue fetch error:', error);
            dispatch({
                type: CATALOGUE_ACTION_TYPES.FETCH_FAILURE,
                payload: { error: error.message },
            });
        }
    };
};